class CountdownTimer2 {
  constructor(element) {
    this.element = element;
    this.endTime = new Date(element.dataset.countdown).getTime();
    this.daysElement = element.querySelector('.days');
    this.hoursElement = element.querySelector('.hours');
    this.minutesElement = element.querySelector('.minutes');
    this.secondsElement = element.querySelector('.seconds');
    
    this.animationFrameId = null;
    this.lastUpdate = 0;
    this.updateInterval = 1000;
    
    this.updateTimer();
    this.startTimer();
  }

  updateTimer() {
    const now = performance.now();
    if (now - this.lastUpdate < this.updateInterval) {
      this.animationFrameId = requestAnimationFrame(() => this.updateTimer());
      return;
    }
    
    this.lastUpdate = now;
    const currentTime = new Date().getTime();
    const distance = this.endTime - currentTime;

    if (distance < 0) {
      this.element.style.display = 'none';
      cancelAnimationFrame(this.animationFrameId);
      return;
    }

    const days = (distance / 86400000) | 0;
    const hours = ((distance % 86400000) / 3600000) | 0;
    const minutes = ((distance % 3600000) / 60000) | 0;
    const seconds = ((distance % 60000) / 1000) | 0;

    const updateElement = (element, value) => {
      const newValue = value.toString().padStart(2, '0');
      if (element.textContent !== newValue) {
        element.textContent = newValue;
      }
    };

    updateElement(this.daysElement, days);
    updateElement(this.hoursElement, hours);
    updateElement(this.minutesElement, minutes);
    updateElement(this.secondsElement, seconds);

    this.animationFrameId = requestAnimationFrame(() => this.updateTimer());
  }

  startTimer() {
    this.animationFrameId = requestAnimationFrame(() => this.updateTimer());
  }

  destroy() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
  }
}

const initCountdownTimers = () => {
  const timers = new Map();
  
  document.querySelectorAll('.countdown-timer').forEach(element => {
    const timer = new CountdownTimer2(element);
    timers.set(element, timer);
  });

  window.addEventListener('unload', () => {
    timers.forEach(timer => timer.destroy());
    timers.clear();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCountdownTimers);
} else {
  initCountdownTimers();
} 